/* ALVA newsletter: submit Shopify "customer" signup forms in place, without reloading the page.
   - A form opts in with the data-alva-nl attribute (home section, cart drawer / cart page).
   - Delegated listeners, so it keeps working when the cart drawer re-renders.
   - Anything unexpected (Shopify's anti-bot check, a timeout, an old browser) falls back to the
     normal browser submit, so the form can never get stuck.
   Texts come from data-* attributes on the form (translated in Liquid), nothing is hardcoded here. */
(function () {
  if (window.__alvaNewsletter) return;
  window.__alvaNewsletter = true;

  var FLAG = 'as-nl-subscribed'; // same flag the cart bar and the Sense popup already read
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var TIMEOUT_MS = 15000;
  var html = document.documentElement;

  function remember() {
    try { localStorage.setItem(FLAG, '1'); } catch (e) {}
    html.classList.add('alva-nl-in');
  }
  try { if (localStorage.getItem(FLAG) === '1') html.classList.add('alva-nl-in'); } catch (e) {}
  // Shopify redirected back after a normal (non-JS) signup
  if (/[?&]customer_posted=true/.test(location.search)) remember();

  function say(form, text, state) {
    var out = form.querySelector('[data-alva-nl-msg]');
    if (!out) return;
    out.textContent = text || '';
    if (text && state) out.setAttribute('data-state', state);
    else out.removeAttribute('data-state');
  }

  function busy(form, on) {
    var btn = form.querySelector('[type="submit"]');
    form.setAttribute('aria-busy', on ? 'true' : 'false');
    if (!btn) return;
    btn.disabled = !!on;
    if (on) {
      btn.setAttribute('data-label', btn.innerHTML);
      var sending = form.getAttribute('data-sending');
      if (sending) btn.textContent = sending;
    } else if (btn.hasAttribute('data-label')) {
      btn.innerHTML = btn.getAttribute('data-label');
      btn.removeAttribute('data-label');
    }
  }

  // The page is about to navigate, so the button keeps its "sending" state.
  function plainSubmit(form) {
    HTMLFormElement.prototype.submit.call(form);
  }

  function succeed(form) {
    remember();
    var wrap = form.closest('[data-alva-nl-root]') || form;
    wrap.classList.add('is-subscribed');
    var body = form.querySelector('[data-alva-nl-body]');
    if (body) body.classList.add('is-done');
    say(form, '', '');
    busy(form, false);
    var target = form.querySelector('[data-alva-nl-focus]');
    if (target) {
      target.setAttribute('tabindex', '-1');
      try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); }
    }
    form.dispatchEvent(new CustomEvent('alva:newsletter-subscribed', { bubbles: true }));
  }

  function fail(form, markup) {
    var message = '';
    try {
      var doc = new DOMParser().parseFromString(markup, 'text/html');
      var el = form.id && doc.querySelector('#' + window.CSS.escape(form.id) + ' [data-alva-nl-msg][data-state="error"]');
      if (el) message = el.textContent.trim();
    } catch (e) {}
    busy(form, false);
    say(form, message || form.getAttribute('data-msg-error') || '', 'error');
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.hasAttribute || !form.hasAttribute('data-alva-nl')) return;
    e.preventDefault();
    if (form.getAttribute('aria-busy') === 'true') return;

    var input = form.querySelector('input[type="email"]');
    var email = input ? input.value.trim() : '';
    if (!EMAIL_RE.test(email)) {
      say(form, form.getAttribute('data-msg-invalid') || '', 'error');
      if (input) input.focus();
      return;
    }
    if (!window.fetch || !window.FormData || !window.URL) { plainSubmit(form); return; }

    say(form, '', '');
    busy(form, true);

    var settled = false;
    function settle() { settled = true; clearTimeout(timer); }
    var timer = setTimeout(function () {
      if (settled) return;
      settled = true;
      plainSubmit(form);
    }, TIMEOUT_MS);

    fetch(form.action, {
      method: 'POST',
      body: new FormData(form),
      credentials: 'same-origin',
      headers: { Accept: 'text/html' }
    }).then(function (res) {
      if (settled) return;
      // Success: Shopify redirects back to the page with ?customer_posted=true
      if (res.ok && /[?&]customer_posted=true/.test(res.url)) { settle(); succeed(form); return; }
      // Shopify's anti-bot check, a rate limit, or a challenge page: let the browser do its normal submit
      if (res.status === 403 || res.status === 429 || /\/challenge/.test(res.url)) { settle(); plainSubmit(form); return; }
      return res.text().then(function (markup) {
        if (settled) return;
        settle();
        fail(form, markup);
      });
    }).catch(function () {
      if (settled) return;
      settle();
      plainSubmit(form);
    });
  });

  // "Copy code" buttons: <button data-alva-copy="CODE" data-copied="Copied!">
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-alva-copy]') : null;
    if (!btn) return;
    var code = btn.getAttribute('data-alva-copy');
    if (!btn.hasAttribute('data-orig')) btn.setAttribute('data-orig', btn.textContent);
    function flash() {
      btn.textContent = btn.getAttribute('data-copied') || btn.getAttribute('data-orig');
      setTimeout(function () { btn.textContent = btn.getAttribute('data-orig'); }, 2000);
    }
    function legacyCopy() {
      var ta = document.createElement('textarea');
      ta.value = code;
      ta.setAttribute('readonly', '');
      ta.style.cssText = 'position:fixed;top:0;left:0;opacity:0';
      document.body.appendChild(ta);
      ta.select();
      var ok = false;
      try { ok = document.execCommand('copy'); } catch (err) {}
      document.body.removeChild(ta);
      if (ok) flash();
    }
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(flash, legacyCopy);
    else legacyCopy();
  });
})();
